import { DateTime } from "luxon";

export function convertToDateTime(dte: string | Date | DateTime): DateTime {
  if (typeof dte === "string") {
    return DateTime.fromISO(dte);
  }

  if (dte instanceof Date) {
    return DateTime.fromJSDate(dte);
  }

  return dte;
}

export function dateFormat(dte: string | Date | DateTime, format: string): string {
  return convertToDateTime(dte).toFormat(format);
}

export function dateStandardFormat(dte: string | Date | DateTime): string {
  return dateFormat(dte, "dd/LL/yyyy");
}

export function timeStandardFormat(dte: string | Date | DateTime): string {
  return dateFormat(dte, "hh:mm:ss a");
}

export function secondsToTime(seconds: number) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
}
